import {ChangeDetectorRef, Component, NgZone, OnInit} from '@angular/core';
import {Resource} from '../../../model/Resource';
import {VerifierService} from '../../../service/verifier.service';
import {ModalDismissReasons, NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ApplicationService} from '../../../service/application.service';
import {Router} from '@angular/router';
import {DocumentService} from '../../../service/document.service';
import {Dialog} from '../../../../global/util/Dialog';
import {InformType} from '../../../../global/util/enum/InformType';
import {Constant} from '../../../../global/util/Constant';
import HttpStatusCode from '../../../../global/util/HttpStatusCode';
import {LocalStorage} from '../../../../global/util/LocalStorage';
import {Document} from '../../../model/Document';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {TypeSignature} from '../../../../global/util/TypeSignature';
import {UanatacaRequest} from '../../../model/UanatacaRequest';
import {UanatacaService} from '../../../service/uanataca.service';
import {Uanatacasignaturelevel} from '../../../model/Uanatacasignaturelevel';
import {SignService} from '../../../service/sign.service';
import {StringUtil} from '../../../../global/util/StringUtil';
import {PersonService} from '../../../service/person.service';
import {SafeUrl} from '@angular/platform-browser';
import {DocumentUtil} from '../../../../global/util/DocumentUtil';
import {StamprubrictemporalList} from '../../../model/StamprubrictemporalList';
import {Stamprubrictemporal} from '../../../model/Stamprubrictemporal';
import {TranslateService} from '@ngx-translate/core';
import {IdentificationDocument} from '../../../../global/util/IdentificationDocument';
import {Person} from '../../../model/Person';
import {SignaturePadComponent} from '../../../../shared/signature-pad/signature-pad.component';
import {CloneTool} from '../../../../global/util/CloneTool';
import {Subject} from 'rxjs';
import {GeolocationIofesign} from '../../../model/GeolocationIofesign';
import {GeolocationService} from '../../../service/geolocation.service';
import {IdentityValidationComponent} from '../../../../shared/identity-validation/identity-validation.component';

@Component({
  selector: 'app-sign-document-internal',
  templateUrl: './sign-document-internal.component.html',
  styleUrls: ['./sign-document-internal.component.css']
})
export class SignDocumentInternalComponent implements OnInit {

  public title = 'TITLE.DOCUMENT-VIEWER';
  public urlStream;
  public document: Document;
  public uanatacaRequest: UanatacaRequest;
  public documents: Document[];
  public resources: Resource[] = [];
  public loading: boolean;
  public reloadingPdf = false;
  public signatureForm: FormGroup;
  public signBoxDataSelected: any;
  public codeOTP: string;
  public username: string;
  public usernameOriginal: string;
  public password: string;
  public reasonForSigning: string;
  public pin: string;
  public codeSent = false;
  public countries: any[] = [];
  public uanatacasignaturelevels: Uanatacasignaturelevel[] = [];
  public countryIdSelected: number;
  public uanatacasignboxdatas: any;
  public certificateDueDate: string;
  private readonly DEFAULT_COUNTRY = 168;
  public viewPassword: boolean;
  public viewPin: boolean;
  public readonly PASSWORD = 1;
  public readonly PIN = 2;
  public previewRubricWidth = '80';
  public rubricSrc: string | ArrayBuffer;
  public resourceList: any[] = [];
  // Lista que almacena las posiciones de las rubricas de cada PDF.
  private positionRubrics: any[];
  public signatureDescriptions: any[] = [];
  public selectedSignatureDescriptions: any[] = [];
  public resource: Resource;
  private value: string;
  public email: string;
  public hasImagesDocument: boolean;
  public documentFrontSrc: string | ArrayBuffer;
  public documentRearSrc: string | ArrayBuffer;
  public person: Person;
  public reloadingPerson: boolean;
  public resourcesChecked: any[] = [];
  public confirmRubricPosition = false;
  public eventsSubject: Subject<void> = new Subject<void>();
  public geolocation: GeolocationIofesign;
  private longitude = null;
  private latitude = null;
  private accuracy = null;
  public identityValidation1 = false;
  randomId = Math.random().toString(36).substring(2);

  constructor(private verifierService: VerifierService,
              private activeModal: NgbActiveModal,
              private modalService: NgbModal,
              private uanatacaService: UanatacaService,
              private cdref: ChangeDetectorRef,
              private applicationService: ApplicationService,
              private signService: SignService,
              private router: Router,
              private ngZone: NgZone,
              private personService: PersonService,
              private formBuilder: FormBuilder,
              private documentService: DocumentService,
              private geolocationService: GeolocationService,
              private translate: TranslateService) {
    Dialog.createInstance(modalService);
    this.createForm();
  }

  ngOnInit(): void {
    this.setDefaultValues();
    this.loadPersonData(this.document._more.personId);
    LocalStorage.removeItem('selectedSignatureDescriptions');
    if (this.document._more.dragRubric) {
      this.getListSignatureDescriptionFromDB();
    }
    this.getCurrentLocation();
  }

  /**
   * Obtiene la lista de las descripcciones disponibles para mostrar en la firma digital.
   */
  public getListSignatureDescriptionFromDB() {
    this.loading = true;
    const url = Constant.ROOT_API_V1.concat('/signaturedescription?personId=', String(LocalStorage.getPersonId()));
    this.documentService.post(url).subscribe(value => {
      this.loading = false;
      this.signatureDescriptions = value;
    }, () => {
      this.loading = false;
      Dialog.show(InformType.Danger, this.title);
    });
  }

  /**
   * Devuelve lista de las descripciones para ser enviadas al formulario del visor de PDF
   */
  public getListSignatureDescription(): any {
    this.selectedSignatureDescriptions = LocalStorage.getSelectedSignatureDescriptions();
    if (this.selectedSignatureDescriptions) {
      return this.selectedSignatureDescriptions;
    } else {
      return this.signatureDescriptions;
    }
  }

  /**
   * Devuelve el identificador de la persona firmante
   */
  public getPersonId(): number {
    return LocalStorage.getPersonId();
  }

  public sign() {
    if (this.acceptRubricPlacementChecked && this.incompleteResources()) {
      this.openModalMessageAlert();
      return;
    }
    if (this.hasConfigDragRubric) {
      this.saveStamprubrictemporary();
    } else {
      if (this.hasDemoNotcer && this.hasNotifyInDocuments) {
        this.verifyDemosNotcer();
      } else if (this.hasConfigBalance) {
        this.verifyUserBalance();
      } else {
        this.sendToSign4TypeSignature();
      }
    }
  }


  public signInCloud() {
    if (this.signatureForm.invalid) {
      Object.values(this.signatureForm.controls).forEach(control => {
        control.markAsTouched();
      });
      return;
    }
    if (this.acceptRubricPlacementChecked && this.incompleteResources()) {
      this.openModalMessageAlert();
      return;
    }
    if (this.hasConfigDragRubric) {
      this.saveStamprubrictemporary();
    } else {
      if (this.hasDemoNotcer && this.hasNotifyInDocuments) {
        this.verifyDemosNotcer();
      } else if (this.hasConfigBalance) {
        this.verifyUserBalance();
      } else {
        this.sendToSign4TypeSignature();
      }
    }
  }

  // TODO Enviar en un formdata y cifrarlo
  public singBox() {
    if (this.signatureForm.invalid) {
      Object.values(this.signatureForm.controls).forEach(control => {
        control.markAsTouched();
      });
      return;
    }
    if (this.acceptRubricPlacementChecked && this.incompleteResources()) {
      this.openModalMessageAlert();
      return;
    }
    if (this.reasonForSigning === undefined) {
      this.reasonForSigning = '';
    }
    if (this.hasConfigDragRubric) {
      this.saveStamprubrictemporary();
    } else {
      if (this.hasDemoNotcer && this.hasNotifyInDocuments) {
        this.verifyDemosNotcer();
      } else if (this.hasConfigBalance) {
        this.verifyUserBalance();
      } else {
        this.sendToSign4TypeSignature();
      }
    }
  }

  /**
   * Evalua el estado de firma remota.
   */
  public checkStatusOne2One(document: Document) {
    const urlOne2One = Constant.ROOT_API_V1.concat('/public/uanataca/signs/one2one/status')
      .concat('?personId=')
      .concat(String(LocalStorage.getPersonId()))
      .concat('&documentId=')
      .concat(String(document.id));
    this.loading = true;
    const interval = setInterval(() => {
      this.documentService.get(urlOne2One).subscribe((next: any) => {
        if (next.completed === Constant.FINISHED) {
          this.loading = false;
          this.activeModal.close(InformType.Success);
          clearInterval(interval);
        }
      }, error => {
        this.loading = false;
        if (HttpStatusCode.FORBIDDEN === error.status) {
          Dialog.show(InformType.Warning, this.translate.instant('TITLE.REMOTE-SIGNATURE'), error.error.message);
          clearInterval(interval);
        } else {
          Dialog.show(InformType.Danger, this.translate.instant('TITLE.DOCUMENT-VIEWER'));
          clearInterval(interval);
        }
      });
    }, 2000);
  }

  public checkStatusBatchSignature(documentIds: string) {
    this.title = this.translate.instant('TITLE.DOCUMENT-VIEWER');
    this.signService.getUUID(LocalStorage.getPersonId(), documentIds).subscribe((next: any) => {
      const checkStatusBatchUrl = Constant.ROOT_API_V1
        .concat('/public/signs/batch/status')
        .concat('?uuid=')
        .concat(next.uuid)
        .concat('&personId=')
        .concat(String(LocalStorage.getPersonId()));
      const interval = setInterval(() => {
        this.documentService.get(checkStatusBatchUrl).subscribe((next2: any) => {
          if (next2.completed === Constant.FINISHED) {
            this.loading = false;
            this.activeModal.close(InformType.Success);
            clearInterval(interval);
          }
        }, error => {
          this.loading = false;
          if (HttpStatusCode.FORBIDDEN === error.status) {
            Dialog.show(InformType.Warning, this.translate.instant('TITLE.REMOTE-SIGNATURE'), error.error.message);
            clearInterval(interval);
          } else {
            Dialog.show(InformType.Danger, this.title);
            clearInterval(interval);
          }
        });
      }, 3000);
    }, error => {
      this.loading = false;
      this.processError(this.title, error);
    });
  }

  public generateOTP() {
    this.loading = true;
    const url = Constant.ROOT_API_V1.concat('/uanataca/requests/', String(this.uanatacaRequest.id), '/otp');
    this.uanatacaService.post(url, null).subscribe(value => {
      this.loading = false;
      const cellphone = this.uanatacaRequest.moreAboutUanatacarequest.phoneNumber;
      const numbers = StringUtil.splitBy(cellphone, 3);
      if (value) {
        this.codeSent = value;
        const btnElement = document.getElementById('btnSendOTP');
        btnElement.setAttribute('disabled', 'disabled');
        Dialog.show(InformType.Success, 'OneSign', this.translate.instant('MESSAGE.CODE-SENT-TO-CELL-PHONE') + cellphone.charAt(0) + '*****' + numbers[numbers.length - 1]);
      }
    }, error => {
      this.loading = false;
      this.activeModal.close(InformType.Danger);
      this.processError(this.translate.instant('TITLE.SIGNATURE'), error);
    });
    setTimeout(() => {
      const btnElement = document.getElementById('btnSendOTP');
      btnElement.removeAttribute('disabled');
    }, 90000);
  }

  public downloadContract() {
    this.loading = true;
    const url = Constant.ROOT_API_V1.concat('/uanataca/requests/', String(this.uanatacaRequest.id), '/contract/stream');
    this.uanatacaService.get(url).subscribe(next => {
      const control = document.createElement('a');
      control.setAttribute('style', 'display:none;');
      document.body.appendChild(control);
      control.href = window.URL.createObjectURL(next);
      control.download = 'contrato.pdf';
      control.click();
      this.loading = false;
    }, () => {
      this.loading = false;
    });
  }


  public cancel() {
    this.activeModal.close(InformType.Anything);
  }

  private setDefaultValues() {
    this.document = this.documents[0];
    this.documents.forEach(document => {
      document._more.resources.forEach(resource1 => this.resources.push(resource1));
    });
    this.loadResourcePerson();
    this.resource = this.resources[0];
    this.resourceList = this.resources;
    this.createEntities();
    this.selectAttachment(this.resources[0]);
    if (this.isCloudSignature && this.resources.length > 10) {
      Dialog.show(InformType.Warning, 'OneSign', this.translate.instant('MESSAGE.LIMIT-EXCEEDS-10-AT-MOST'));
      this.activeModal.close();
      return;
    }
    if (this.isRemoteSignature) {
      this.countries = LocalStorage.getCountries();
      this.countryIdSelected = this.DEFAULT_COUNTRY;
      this.signatureForm.get('username').setValidators(Validators.required);
      this.signatureForm.get('password').setValidators(Validators.required);
      this.signatureForm.get('pin').setValidators(Validators.required);
      this.signatureForm.get('username').updateValueAndValidity();
      this.signatureForm.get('password').updateValueAndValidity();
      this.signatureForm.get('pin').updateValueAndValidity();
    }
    if (this.isCloudSignature) {
      this.codeSent = this.uanatacaRequest.moreAboutUanatacarequest.codeOTPActive;
      this.signatureForm.get('codeOTP').setValidators(
        Validators.compose(
          [
            Validators.required,
            Validators.pattern('^[0-9]{6}')])
      );
      this.signatureForm.get('codeOTP').updateValueAndValidity();
    }
  }

  public selectAttachment(resource: Resource) {
    this.resource = resource;
    this.getStream();
  }

  private processError(title: string, error: any) {
    const status = error.status;
    if (status) {
      if (HttpStatusCode.UNAUTHORIZED === status) {
        Dialog.show(InformType.Danger, title, error.error.message);
      } else if (HttpStatusCode.FORBIDDEN === status) {
        Dialog.show(InformType.Info, this.translate.instant('TITLE.SESSION-EXPIRED'), this.translate.instant('MESSAGE.SESSION-EXPIRED'));
        this.logout();
      } else if (HttpStatusCode.SERVICE_UNAVAILABLE === status) {
        Dialog.show(InformType.Danger, title, error.error.message, 160);
      } else {
        Dialog.show(InformType.Danger, title);
      }
    } else {
      Dialog.show(InformType.Danger, title, error.error.message);
    }
  }

  private logout() {
    this.applicationService.setUserLoggedIn(false);
    this.router.navigate(['login']);
  }

  private createForm() {
    this.signatureForm = this.formBuilder.group({
      codeOTP: [''],
      username: [''],
      password: [''],
      pin: [''],
      uanatacasignaturelevel: [''],
      country: [''],
      reason: [''],
      groupRadio: [''],
      page: [''],
      resource: [''],
      anotherPage: [''],
      pagesTotal: [''],
      rubricFileBase64: [''],
      rubricFilename: [''],
      rubricFilename2Show: [''],
      documentFrontFileBase64: [''],
      documentFrontFilename: [''],
      documentFrontFilename2Show: [''],
      documentRearFileBase64: [''],
      documentRearFilename: [''],
      documentRearFilename2Show: ['']
    });
  }

  public isInvalidControl(ctrlName: string) {
    return this.signatureForm.get(ctrlName).invalid && this.signatureForm.get(ctrlName).touched;
  }

  get isCloudSignature(): boolean {
    return TypeSignature.CLOUD === this.document._more.typeSignature;
  }

  get isNotify(): boolean {
    return TypeSignature.ANYTHING === this.document._more.typeSignature;
  }

  get isElectronicSignature(): boolean {
    return TypeSignature.ELECTRONIC === this.document._more.typeSignature;
  }

  get isRemoteSignature(): boolean {
    return TypeSignature.REMOTE === this.document._more.typeSignature;
  }

  public search(data: any) {
    if (data.target.value !== this.usernameOriginal) {
      this.certificateDueDate = '';
    }
    this.uanatacasignboxdatas = [];
    const user = data.target.value;
    if (user.length > 3) {
      this.uanatacaService.search(LocalStorage.getPersonId(), user).subscribe((next: any) => {
        if (next._embedded) {
          this.uanatacasignboxdatas = next._embedded.uanatacasignboxdata;
        }
      });
    }
  }

  public onSignboxDataChanged(userSelected) {
    const listElement = userSelected.split('-');
    const username = listElement[Constant.ZERO_INDEX].trim();
    this.signBoxDataSelected = this.uanatacasignboxdatas.find(value => value.user === username);
    if (this.signBoxDataSelected) {
      this.username = this.signBoxDataSelected.user;
      this.usernameOriginal = this.signBoxDataSelected.user;
      this.reasonForSigning = this.signBoxDataSelected.reason;
      this.certificateDueDate = this.signBoxDataSelected.certificateDueDate;
    }
  }

  public hasCertificateDueDate(certificateDueDate) {
    if (certificateDueDate) {
      return true;
    } else {
      return false;
    }
  }

  public toggleFieldTextType(passwordType: number) {
    if (this.PASSWORD === passwordType) {
      this.viewPassword = !this.viewPassword;
    } else if (this.PIN === passwordType) {
      this.viewPin = !this.viewPin;
    }
  }


  isCertificateDueDateCorrect(certificateDueDateCorrect: any) {
    if (certificateDueDateCorrect) {
      return new Date(certificateDueDateCorrect) > new Date();
    }
  }

  public changeStatus(event: any) {
    const testFile = event[Constant.ZERO_INDEX];
    this.signatureForm.patchValue({
      rubricFileBase64: testFile.base64,
      rubricFilename: testFile.name,
      rubricFilename2Show: StringUtil.cut(testFile.name, 42, this.translate.instant('MESSAGE.SELECT')),
    });
    this.updateValueAndValidityRubricFields();
    this.updateRubric();
  }

  private updateValueAndValidityRubricFields() {
    this.signatureForm.get('rubricFileBase64').updateValueAndValidity();
    this.signatureForm.get('rubricFilename').updateValueAndValidity();
    this.signatureForm.get('rubricFilename2Show').updateValueAndValidity();
  }

  public updateRubric(): void {
    this.reloadingPdf = true;
    const rubricFileBase64: string = this.signatureForm.get('rubricFileBase64').value;
    const rubricFilename: string = this.signatureForm.get('rubricFilename').value;
    const url = Constant.ROOT_API_V1.concat('/people/', String(LocalStorage.getPersonId()), '/rubric');
    this.personService.updateRubric(url, rubricFileBase64, rubricFilename).subscribe(() => {
      this.reloadingPdf = false;
    }, () => {
      this.reloadingPdf = false;
      Dialog.show(InformType.Danger, this.translate.instant('TITLE.RUBRIC-UPDATE'));
    });
  }

  /**
   * Obtiene el pdf desde el API y crea un objeto con este mismo.
   */
  public getStream(): void {
    this.reloadingPdf = true;
    const url = this.resource.url2;
    this.documentService.download(url).subscribe(value => {
      // @ts-ignore
      const file = new Blob([value], {type: 'application/pdf'});
      this.urlStream = URL.createObjectURL(file);
      this.reloadingPdf = false;
    }, () => {
      this.reloadingPdf = false;
    });
  }

  /**
   * Crea la posiciones temporales al inicio de la carga de la pagina.
   * @private
   */
  private createEntities() {
    if (this.document._more.positions) {
      this.positionRubrics = this.resourceList.map(value => {
        const position = this.document._more.positions;
        const positionSplitted = position.split(',', 6);
        const positionRubricInfo: Stamprubrictemporal = {
          resourceId: value.id,
          documentId: value.documentId,
          positionX: Number(positionSplitted[0]),
          positionY: Number(positionSplitted[1]),
          positionXf: Number(positionSplitted[2]),
          positionYf: Number(positionSplitted[3]),
          signaturedescriptionIds: null,
          pageStamp: Number(positionSplitted[4]),
          page: Number(positionSplitted[5]),
        };
        return positionRubricInfo;
      });
      LocalStorage.setItem('positionRubrics', this.positionRubrics);
    }
  }

  /**
   * Guarda las posiciones temporales de la rubrica.
   * @private
   */
  private saveStamprubrictemporary() {
    this.loading = true;
    const url = Constant.ROOT_API_V1.concat('/public/people/', String(LocalStorage.getPersonId()), '/stamprubrictemporary');
    const stamprubrictemporalinfo = new StamprubrictemporalList();
    this.getCurrentPositions();
    if (this.isDigitalSignature) {
      this.selectedSignatureDescriptions = LocalStorage.getSelectedSignatureDescriptions();
      if (this.selectedSignatureDescriptions) {
        this.signatureDescriptions = this.selectedSignatureDescriptions;
      }
      const SelectedSignatureDescription = this.signatureDescriptions.filter(value => value.initialized === true);
      const docIdentifiers = StringUtil.concatIdentifiers(SelectedSignatureDescription);
      this.positionRubrics.forEach(value => value.signaturedescriptionIds = docIdentifiers);
    }
    stamprubrictemporalinfo.stamprubrictemporals = this.positionRubrics;
    this.signService.save(url, stamprubrictemporalinfo).subscribe(() => {
      this.loading = false;
      if (this.hasDemoNotcer && this.hasNotifyInDocuments) {
        this.verifyDemosNotcer();
      } else if (this.hasConfigBalance) {
        this.verifyUserBalance();
      } else {
        this.sendToSign4TypeSignature();
      }
    }, () => {
      Dialog.show(InformType.Danger, this.translate.instant('TITLE.DOCUMENT-VIEWER'));
      this.loading = false;
    });
  }

  /**
   * Verifica si el usuario tiene demos de NOTCER
   */
  public verifyDemosNotcer() {
    this.loading = true;
    const url = Constant.ROOT_API_V1.concat('/people/', String(LocalStorage.getPersonId()), '/documents/verify/demonotcer');
    this.documentService.verifyUserBalanceOrDemoNotcer(url, this.documents).subscribe(() => {
      this.sendToSign4TypeSignature();
    }, error => {
      this.loading = false;
      if (HttpStatusCode.UPGRADE_REQUIRED === error.status) {
        Dialog.show(InformType.Warning, this.translate.instant('TABLE.HEADER.BALANCE-IOF'), error.error.message);
        return;
      } else if (HttpStatusCode.PRECONDITION_REQUIRED === error.status) {
        Dialog.show(InformType.Warning, this.translate.instant('TITLE.NOTIFY'), error.error.message);
        return;
      }
      this.activeModal.close(InformType.Danger);
      this.processError(this.translate.instant('TITLE.SIGNATURE'), error);
    });
  }

  /**
   * Verifica si el usuario tiene el saldo suficiente para realizar esta acción
   */
  public verifyUserBalance() {
    this.loading = true;
    const url = Constant.ROOT_API_V1.concat('/people/', String(LocalStorage.getPersonId()), '/documents/verify/userbalance');
    this.documentService.verifyUserBalanceOrDemoNotcer(url, this.documents).subscribe(() => {
      this.sendToSign4TypeSignature();
    }, error => {
      this.loading = false;
      if (HttpStatusCode.UPGRADE_REQUIRED === error.status) {
        Dialog.show(InformType.Warning, this.translate.instant('TABLE.HEADER.BALANCE-IOF'), error.error.message);
        return;
      }
      this.activeModal.close(InformType.Danger);
      this.processError(this.translate.instant('TITLE.SIGNATURE'), error);
    });
  }

  public signElectronic() {
    this.loading = true;
    const url = Constant.ROOT_API_V1.concat('/people/', String(LocalStorage.getPersonId()), '/documents/sign');
    this.documentService.signElectronically(url, this.documents).subscribe(() => {
      this.loading = false;
      this.saveGeolocation(this.documents, this.getPersonId(), 'Firma gráfica');
      this.activeModal.close(InformType.Success);
    }, error => {
      this.loading = false;
      if (HttpStatusCode.UPGRADE_REQUIRED === error.status) {
        Dialog.show(InformType.Warning, this.translate.instant('TITLE.SIGNATURE'), error.error.message);
        return;
      }
      this.activeModal.close(InformType.Danger);
      this.processError(this.translate.instant('TITLE.SIGNATURE'), error);
    });
  }

  public openModalSignDocumentInternal3() {
    const modalRef = this.modalService.open(IdentityValidationComponent, {
      backdrop: 'static',
      size: 'lg',
      animation: true,
      keyboard: false
    });
    this.person.documentId = this.document.id;
    modalRef.componentInstance.person = this.person;
    modalRef.componentInstance.isPublic = false;
    modalRef.result.then((result) => {
      const informType = result.informType;
      if (InformType.Success === informType) {
        Dialog.show(InformType.Success, this.translate.instant('TITLE.IDENTITY-VALIDATION'), 'Validación de identidad correcta');
        this.identityValidation1 = true;
      }
      if (InformType.Anything === informType) {
        this.activeModal.close();
      }
      this.loading = false;
    }, reason => {
      if (reason === ModalDismissReasons.ESC) {
      }
    });
  }


  /**
   * Firma de documetnos segun el tipo de firma.
   */
  public sendToSign4TypeSignature() {
    let url;
    switch (this.document._more.typeSignature) {
      case TypeSignature.DIGITAL:
        if (this.resources.length > 1) {
          this.signDigitalBatch();
        } else {
          this.openRCDSignatureOne2One(this.documents[0]);
          this.checkStatusOne2OneDigital(this.documents[0]);
        }
        break;
      case TypeSignature.ELECTRONIC:
        if (this.hasIdentityValidation) {
          if (this.identityValidation1) {
            this.signElectronic();
          } else {
            Dialog.show(InformType.Warning, this.translate.instant('TITLE.IDENTITY-VALIDATION'), 'Usted no realizo la validación de identidad');
          }
        } else {
          this.signElectronic();
        }
        break;
      case TypeSignature.REMOTE:
        this.loading = true;
        url = Constant.ROOT_API_V1.concat('/uanataca/people/sign/remote');
        const formData = new FormData();

        const docIdentifiers = StringUtil.concatIdentifiers(this.documents);
        formData.append('personId', String(LocalStorage.getPersonId()));
        formData.append('username', this.signatureForm.get('username').value );
        formData.append('password', this.signatureForm.get('password').value);
        formData.append('pin', this.signatureForm.get('pin').value);
        formData.append('docIdentifiers', docIdentifiers);
        formData.append('countryId', String(this.countryIdSelected));
        formData.append('reason', this.reasonForSigning);
        this.uanatacaService.post1(url, formData).subscribe(value => {
          if (value) {
            this.saveGeolocation(this.documents, this.getPersonId(), 'Firma remota');
            if (this.documents.length === 1) {
              this.checkStatusOne2One(this.documents[Constant.ZERO_INDEX]);
            } else {
              this.checkStatusBatchSignature(docIdentifiers);
            }
          }
        }, error => {
          this.loading = false;
          if (HttpStatusCode.FORBIDDEN === error.status) {
            Dialog.show(InformType.Warning, this.translate.instant('TITLE.REMOTE-SIGNATURE'), error.error.message);
            return;
          } else if (HttpStatusCode.INTERNAL_SERVER_ERROR === error.status) {
            Dialog.show(InformType.Danger, this.translate.instant('TITLE.REMOTE-SIGNATURE'), error.error.message);
            this.activeModal.close(InformType.Danger);
          } else if (HttpStatusCode.UPGRADE_REQUIRED === error.status) {
            Dialog.show(InformType.Warning, this.translate.instant('TITLE.REMOTE-SIGNATURE'), error.error.message);
            return;
          }
          this.activeModal.close(InformType.Danger);
          this.processError('Firma', error);
        });
        break;
      case TypeSignature.CLOUD:
        this.loading = true;
        url = Constant.ROOT_API_V1.concat('/uanataca/requests/', String(this.uanatacaRequest.id), '/codeotp/', this.codeOTP, '/documents/sign');
        this.uanatacaService.post(url, this.documents).subscribe(value => {
          this.loading = false;
          if (value) {
            this.saveGeolocation(this.documents, this.getPersonId(), 'Firma OneSign');
            this.activeModal.close(InformType.Success);
          }
        }, error => {
          this.loading = false;
          if (HttpStatusCode.FORBIDDEN === error.status) {
            Dialog.show(InformType.Warning, 'OneSign', error.error.message);
            return;
          } else if (HttpStatusCode.INTERNAL_SERVER_ERROR === error.status) {
            Dialog.show(InformType.Danger, 'OneSign', error.error.message);
            this.activeModal.close(InformType.Danger);
          } else if (HttpStatusCode.UPGRADE_REQUIRED === error.status) {
            Dialog.show(InformType.Warning, 'OneSign', error.error.message);
            return;
          }
          this.activeModal.close(InformType.Danger);
          this.processError('Firma', error);
        });
        break;
      case TypeSignature.ANYTHING:
        this.loading = true;
        url = Constant.ROOT_API_V1.concat('/people/', String(LocalStorage.getPersonId()), '/documents/sign');
        this.documentService.signElectronically(url, this.documents).subscribe(() => {
          this.loading = false;
          this.saveGeolocation(this.documents, this.getPersonId(), 'Notificación');
          this.activeModal.close(InformType.Success);
        }, error => {
          this.loading = false;
          if (HttpStatusCode.UPGRADE_REQUIRED === error.status) {
            Dialog.show(InformType.Warning, this.translate.instant('TITLE.NOTIFY'), error.error.message);
            return;
          }
          this.activeModal.close(InformType.Danger);
          this.processError(this.translate.instant('TITLE.SIGNATURE'), error);
        });
        break;
    }
  }

  /**
   * Obtiene las posiciones actuales de la rúbrica de todos los documentos.
   * @private
   */
  private getCurrentPositions() {
    this.positionRubrics = LocalStorage.getPositionRubrics();
  }

  private loadRubricSrc(person: Person) {
    if (document && person._more.rubricFileExtension && person._more.base64RubricFile) {
      this.rubricSrc = 'data:image/' + person._more.rubricFileExtension + ';base64,' + person._more.base64RubricFile;
    } else {
      this.rubricSrc = this.placeHoldItRubric;
    }
  }

  get placeHoldItRubric(): string {
    return Constant.DEFAULT_IMAGE_PATH_80_40;
  }

  get defaultRubricSrc(): string | ArrayBuffer {
    return this.rubricSrc || this.placeHoldItRubric;
  }

  get styleDimensionsRubric(): string {
    return 'width: ' + this.previewRubricWidth + 'px; height: auto';
  }

  get hasConfigDragRubric(): boolean {
    return !this.isCloseStampingAndIsNotDigitalSignature && this.hasConfigRubric && this.hasDragRubric;
  }

  public digitalSign() {
    if (this.signatureForm.invalid) {
      Object.values(this.signatureForm.controls).forEach(control => {
        control.markAsTouched();
      });
      return;
    }
    if (this.acceptRubricPlacementChecked && this.incompleteResources()) {
      this.openModalMessageAlert();
      return;
    }
    if (this.hasConfigDragRubric) {
      this.saveStamprubrictemporary();
    } else {
      if (this.hasDemoNotcer && this.hasNotifyInDocuments) {
        this.verifyDemosNotcer();
      } else if (this.hasConfigBalance) {
        this.verifyUserBalance();
      } else {
        this.sendToSign4TypeSignature();
      }
    }
  }

  public signDigitalBatch() {
    if (this.acceptRubricPlacementChecked && this.incompleteResources()) {
      this.openModalMessageAlert();
      return;
    }
    const documentIds = StringUtil.concatIdentifiers(this.documents);
    this.title = this.translate.instant('TITLE.DOCUMENT-VIEWER');
    this.signService.getUUID(LocalStorage.getPersonId(), documentIds).subscribe((next: any) => {
      const fromUrl = Constant.ROOT_API_V1
        .concat('/public/signs/batch/stream?uuid=')
        .concat(next.uuid);
      const rsignUrl = 'rsign:?batch_csv='.concat(fromUrl);
      window.open(rsignUrl, '_self');
      const checkStatusBatchUrl = Constant.ROOT_API_V1
        .concat('/public/signs/batch/status')
        .concat('?uuid=')
        .concat(next.uuid)
        .concat('&personId=')
        .concat(String(LocalStorage.getPersonId()));
      this.loading = true;
      setInterval(() => {
        this.documentService.get(checkStatusBatchUrl).subscribe((next2: any) => {
          if (next2.completed === Constant.FINISHED) {
            this.loading = false;
            this.saveGeolocation(this.documents, this.getPersonId(), 'Firma digital');
            this.activeModal.close(InformType.Success);
          }
        }, error => {
          this.processError(this.title, error);
        });
      }, 3000);
    }, error => {
      this.processError(this.title, error);
    });
  }

  openRCDSignatureOne2One(document: Document): void {
    const rsignUrl = this.getUrlsSign(document).toString();
    window.open(rsignUrl, '_self');
  }

  public checkStatusOne2OneDigital(document: Document) {
    const urlOne2One = Constant.ROOT_API_V1.concat('/public/signs/one2one/status')
      .concat('?personId=')
      .concat(String(LocalStorage.getPersonId()))
      .concat('&documentId=')
      .concat(String(document.id));
    this.loading = true;
    const interval = setInterval(() => {
      this.documentService.get(urlOne2One).subscribe((next: any) => {
        if (next.completed === Constant.FINISHED) {
          this.activeModal.close(InformType.Success);
          this.saveGeolocation(this.documents, this.getPersonId(), 'Firma digital');
          clearInterval(interval);
          this.loading = false;
          this.activeModal.close(InformType.Success);
        }
      }, error => {
        this.processError(this.translate.instant('TITLE.DOCUMENT-VIEWER'), error);
      });
    }, 2000);
  }

  get isCloseStampingAndIsNotDigitalSignature(): boolean {
    if (this.document !== undefined) {
      return this.document.closedStamping && !this.isDigitalSignature && !this.isCloudSignature && !this.isRemoteSignature;
    }
  }

  public getUrlsSign(document: Document): SafeUrl {
    const urlFrom = DocumentUtil.buildUrlDownload(document, LocalStorage.getPersonId());
    const urlTo = DocumentUtil.buildUrlUpload(document, LocalStorage.getPersonId());
    if (this.hasConfigDragRubric) {
      const description = this.getSignatureDescription();
      const stampOn = this.positionRubrics[0].page === 0 ? 1 : this.positionRubrics[0].page;
      return 'rsign:?from='
        .concat(urlFrom)
        .concat('&to=')
        .concat(urlTo)
        .concat('&vis_sig_x=')
        .concat(String(this.positionRubrics[0].positionX))
        .concat('&vis_sig_y=')
        .concat(String(this.positionRubrics[0].positionY))
        .concat('&vis_sig_width=')
        .concat(String(this.positionRubrics[0].positionXf))
        .concat('&vis_sig_height=')
        .concat(String(this.positionRubrics[0].positionYf))
        .concat('&vis_sig_text=')
        .concat(description)
        .concat('&vis_sig_page=')
        .concat(String(stampOn))
        .concat('&vis_sig_image=')
        .concat(String(Constant.ROOT_API_V1 + '/public/people/' + LocalStorage.getPersonId() + '/rubrics'));
    }
    return 'rsign:?from='
      .concat(urlFrom)
      .concat('&to=')
      .concat(urlTo);
  }

  /**
   * Obtiene la descripcciones de firma digital para ser enviadas al componente de firma.
   */
  public getSignatureDescription(): string {
    this.selectedSignatureDescriptions = LocalStorage.getSelectedSignatureDescriptions();
    if (this.selectedSignatureDescriptions) {
      this.signatureDescriptions = this.selectedSignatureDescriptions;
    }
    let value = '';
    for (const signatureDescription of this.signatureDescriptions) {
      if (signatureDescription.initialized) {
        value += ''
          .concat(signatureDescription.description)
          .concat('%0A');
      }
    }
    value = value.replace('<RUC>', LocalStorage.getEnterpriseDocumentNumber());
    value = value.replace('<ENTERPRISE>', LocalStorage.getEnterpriseName());
    // Se codificara el caracter especial '&' para evitar problemas con el componente de firma
    value = value.replace('&', '%26');
    return StringUtil.removeCharacter(value, 3);
  }

  /*Verificamos si el código solicitado es para firma OneSign o firma Gráfica*/
  generateCodeOrOTP() {
    if (this.isCloudSignature) {
      this.generateOTP();
    } else if (this.isElectronicSignature && this.haveDocumentIntegrityToGraficSign) {
      this.generateCode();
    }
  }

  /*En este método antes de realizar la firma verificamos si documentIntegrity este en "true"
  * Si es el caso se verifica el código de verificación para proceder con la firma del documento.*/
  signGraphic() {
    if (this.isElectronicSignature && this.haveDocumentIntegrityToGraficSign) {
      const code = this.signatureForm.get('codeOTP').value;
      if (code === '' || code === undefined) {
        Dialog.show(InformType.Warning, this.translate.instant('TITLE.VERIFICATION-CODE'), this.translate.instant('MESSAGE.ENTER-CODE-OR-REQUEST-NEW-CODE'));
        return;
      }
      if (this.acceptRubricPlacementChecked && this.incompleteResources()) {
        this.openModalMessageAlert();
        return;
      }
      const url = Constant.ROOT_API_V1 + '/public/verify-verification-code?code='.concat(code).concat('&value=').concat(this.value);
      this.applicationService.get(url).subscribe((value: any) => {
        if (value.validVerificationCode) {
          this.sign();
        } else {
          Dialog.show(InformType.Danger, this.translate.instant('TITLE.VERIFICATION-CODE'), this.translate.instant('MESSAGE.OPERATION-NOT-COMPLETED-BY-INCORRECT-CODE'));
        }
      }, () => {
        Dialog.show(InformType.Danger, this.translate.instant(this.title));
      });
    } else {
      this.sign();
    }
  }

  getDocumentType(documentType) {
    return Constant.DNI === Number(documentType) ? IdentificationDocument.dDNI : (Constant.CARNE_EXTRANJERIA === Number(documentType) ? IdentificationDocument.dCE : IdentificationDocument.dPAS);
  }

  /*Método obtiene información necesaria del firmante para luego enviar el código de verificación para la firma grafica.*/
  generateCode() {
    const url = Constant.ROOT_API_V1.concat('/public/people?personId=').concat(String(this.document._more.personId));
    this.applicationService.get(url).subscribe((next: any) => {
      this.getUUID(next);
    });
  }

  /*Se obtiene el identificador unico universal*/
  private getUUID(next): void {
    const url = Constant.ROOT_API_V1 + '/public/uuid';
    this.applicationService.get(url).subscribe((value: any) => {
      this.sendVerificationCode(next, value.uuid);
    }, () => {
      Dialog.show(InformType.Danger, this.translate.instant('TITLE.OBTAINING-UUID'));
    });
  }

  /**
   * Este método registra el código y luego envía al correo del usuario para la firma del documento.
   */
  public sendVerificationCode(next: any, uuid?: string): void {
    const url = Constant.ROOT_API_V1 + '/public/send-verification-code/save/traceability';
    this.value = this.getDocumentType(next.documentType).concat('_').concat(next.documentNumber);
    this.email = next.email;
    const formData = new FormData();
    formData.append('documentId', String(this.document.id));
    formData.append('uuid', uuid);
    formData.append('value', this.value);
    formData.append('email', this.email);
    this.loading = true;
    this.applicationService.post(url, formData).subscribe(() => {
      this.loading = false;
      const numbers = StringUtil.splitBy(this.email, 3);
      this.email = this.email.charAt(0) + this.email.charAt(1) + '***********' + numbers[numbers.length - 1];
      Dialog.show(InformType.Info, this.translate.instant('TITLE.VERIFICATION-CODE'), this.translate.instant('MESSAGE.SEND-VERIFICATION-CODE-TO-EMAIL').replace('P_EMAIL', this.email));
    }, () => {
      this.loading = false;
      Dialog.show(InformType.Danger, this.translate.instant('TITLE.VERIFICATION-CODE'), this.translate.instant('MESSAGE.ERROR-OCCURRED-TO-SEND-VERIFICATION-CODE'));
    });
  }

  /**
   * Actualiza las imágenes del documento de identidad y las rúbricas de ser necesarias
   */
  public updateImages(): void {
    if (this.signatureForm.invalid) {
      Object.values(this.signatureForm.controls).forEach(control => {
        control.markAsTouched();
      });
      return;
    }
    this.setFinalValuesBefore2Save();
    this.loading = true;
    const url = Constant.ROOT_API_V1.concat('/people/images/');
    this.personService.update(url, this.person).subscribe(() => {
      this.loading = false;
      // tslint:disable-next-line:no-unused-expression
      this.haveDocIdentificationImages(this.person);
      Dialog.show(InformType.Success, this.translate.instant('TITLE.CORRECTLY-COMPLETED-DATA'), this.translate.instant('MESSAGE.THE-OPERATION-WAS-SUCCESSFULLY-COMPLETED'));
    }, () => {
      this.loading = false;
    });
  }

  setFinalValuesBefore2Save() {
    this.person.rubricBase64Data = this.signatureForm.get('rubricFileBase64').value;
    this.person.rubricFilename = this.signatureForm.get('rubricFilename').value;
    this.person.documentFrontBase64Data = this.signatureForm.get('documentFrontFileBase64').value;
    this.person.documentFrontFilename = this.signatureForm.get('documentFrontFilename').value;
    this.person.documentRearBase64Data = this.signatureForm.get('documentRearFileBase64').value;
    this.person.documentRearFilename = this.signatureForm.get('documentRearFilename').value;
  }

  private loadPersonData(personId: number) {
    // if (this.haveDocumentIntegrityToGraficSign) {
    const urlPerson = Constant.ROOT_API_V1.concat('/people?personId=').concat(String(personId));
    this.reloadingPerson = true;
    this.personService.get(urlPerson).subscribe((next: Person) => {
      this.person = next;
      setTimeout(() => {
        this.loadFrontSrc(this.person);
        this.loadRearSrc(this.person);
        this.reloadingPerson = false;
      }, 10);
      if (this.hasIdentityValidation) {
        this.openModalSignDocumentInternal3();
      }
    }, () => {
      this.reloadingPerson = false;
      Dialog.show(InformType.Danger, this.translate.instant('TITLE.SIGNATURE-DOCUMENTS'));
    });
    // }
  }

  /**
   * Carga de imagen frontal del documento de identidad.
   * @param person
   * @private
   */
  private loadFrontSrc(person: Person) {
    if (person && person._more.documentFrontFileExtension && person._more.documentFrontBase64Data) {
      this.documentFrontSrc = 'data:image/' + person._more.documentFrontFileExtension + ';base64,' + person._more.documentFrontBase64Data;
    } else {
      this.documentFrontSrc = this.placeHoldItRubric;
    }
  }

  /**
   * Carga de imagen posterior del documento de identidad.
   * @param person
   * @private
   */
  private loadRearSrc(person: Person) {
    if (person && person._more.documentRearFileExtension && person._more.documentRearBase64Data) {
      this.documentRearSrc = 'data:image/' + person._more.documentRearFileExtension + ';base64,' + person._more.documentRearBase64Data;
    } else {
      this.documentRearSrc = this.placeHoldItRubric;
    }
  }

  /**
   * Muestra el modal signaturePad donde el usuario puede agregar o dibujar su rubrica
   */
  signaturePad() {
    const modalRef = this.modalService.open(SignaturePadComponent, {
      windowClass: 'my-class-signature-pad'
    });
    modalRef.componentInstance.isInvited = false;
    modalRef.result.then((result) => {
      if (InformType.Success === result) {
        this.updateLastRubric();
      } else if (InformType.Danger === result) {
      }
    });
  }

  /**
   * Actualiza la rubrica que es mostrada al momento de firmar.
   */
  updateLastRubric() {
    this.reloadingPdf = true;
    this.rubricSrc = LocalStorage.getRubricrubricFile();
    LocalStorage.removeItem('rubricFile');
    this.reloadingPdf = false;
    if (!this.hasDragRubric) {
      this.getStream();
    }
  }

  public readSelectedDocumentFront(event: any): void {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.onload = () => this.documentFrontSrc = reader.result;
      reader.readAsDataURL(file);
    }
  }

  public readSelectedBackDNI(event: any): void {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.onload = () => this.documentRearSrc = reader.result;
      reader.readAsDataURL(file);
    }
  }

  /**
   * Obtiene la rubica de la persona.
   * @private
   */
  private loadResourcePerson() {
    this.loading = true;
    this.personService.loadResourcePerson1(String(LocalStorage.getPersonId())).subscribe(resourcePerson => {
      this.loading = false;
      if (resourcePerson) {
        this.loadRubricSrc(resourcePerson);
        this.hasImagesDocument = resourcePerson._more.hasImagesDocument;
      }
    }, () => {
      this.loading = false;
    });
  }

  public changeStatus3(event: any) {
    const testFile = event[Constant.ZERO_INDEX];
    this.signatureForm.patchValue({
      documentFrontFileBase64: testFile.base64,
      documentFrontFilename: testFile.name,
      documentFrontFilename2Show: StringUtil.cut(testFile.name, 42, this.translate.instant('MESSAGE.SELECT')),
    });
    this.updateValueAndValidityObverseDNIFields();
  }

  public changeStatus4(event: any) {
    const testFile = event[Constant.ZERO_INDEX];
    this.signatureForm.patchValue({
      documentRearFileBase64: testFile.base64,
      documentRearFilename: testFile.name,
      documentRearFilename2Show: StringUtil.cut(testFile.name, 42, this.translate.instant('MESSAGE.SELECT')),
    });
    this.updateValueAndValidityBackDNIFields();
  }

  private updateValueAndValidityObverseDNIFields() {
    this.signatureForm.get('documentFrontFileBase64').updateValueAndValidity();
    this.signatureForm.get('documentFrontFilename').updateValueAndValidity();
    this.signatureForm.get('documentFrontFilename2Show').updateValueAndValidity();
  }

  private updateValueAndValidityBackDNIFields() {
    this.signatureForm.get('documentRearFileBase64').updateValueAndValidity();
    this.signatureForm.get('documentRearFilename').updateValueAndValidity();
    this.signatureForm.get('documentRearFilename2Show').updateValueAndValidity();
  }

  haveDocIdentificationImages(person) {
    return person ? person._more.documentFrontBase64Data && person._more.documentRearBase64Data || this.docIdentificationImagesSaved(person) : false;
  }

  docIdentificationImagesSaved(person) {
    return person ? person.documentFrontBase64Data && person.documentRearBase64Data : false;
  }

  wasSelected2(resource1: Resource) {
    return this.resourcesChecked.find(resource => resource1.id === resource.id) !== undefined;
  }

  addRemoveResource(event: any, resource: Resource) {
    this.selectAttachment(resource);
    const index = this.resourcesChecked.findIndex(resource1 => resource.id === resource1.id);
    if (event.target.checked) {
      const clonedResource = CloneTool.do(resource);
      const resourcePushed = this.resourcesChecked.find(resource1 => resource.id === resource1.id);
      if (!resourcePushed && resource.sign) {
        this.resourcesChecked.push(clonedResource);
      }
    } else {
      this.resourcesChecked.splice(index, 1);
    }
  }

  /**
   * Marca con un check todos los adjuntos del documento cuando se realiza el dragdrop de la imagen.
   * @param resource
   */
  wasChecked(resource: any) {
    return this.resourcesChecked.find(resource1 => resource1.id === resource.id);
  }

  /**
   * Espera una respuesa del componente hijo para actualizar el adjunto como checkeado.
   * @param resource
   */
  rubricDragEnd(resource: any) {
    console.log('Rubric dragEnd');
    const resourcePushed = this.resourcesChecked.find(resource1 => resource.id === resource1.id);
    if (!resourcePushed && resource.sign) {
      const clonedResource = CloneTool.do(resource);
      this.resourcesChecked.push(clonedResource);
    }
    this.wasChecked(resource);
    this.wasSelected2(resource);
  }

  addOrRemoveAll(event: any) {
    if (event.target.checked) {
      this.resources.forEach(resource => {
        const resourcePushed = this.resourcesChecked.find(resource1 => resource.id === resource1.id);
        if (!resourcePushed && resource.sign) {
          const clonedResource = CloneTool.do(resource);
          this.resourcesChecked.push(clonedResource);
        }
      });
    } else {
      this.resourcesChecked = [];
    }
  }

  cutFileName(fileName: string) {
    const maxLength = 30;
    return fileName.length > maxLength ? fileName.substring(0, 10) + ' .... ' + fileName.substring(fileName.length - 15) : fileName;
  }


  wasAllSelected1() {
    return this.resourcesChecked.length === this.resources.length;
  }

  incompleteResources() {
    const signResources = this.resources.filter(resource => resource.sign === true);
    return this.resourcesChecked.length !== signResources.length;
  }

  private openModalMessageAlert() {
    let fileName = '';

    function BreakException(message) {
      this.message = message;
      this.name = 'Exception';
    }

    this.resources.forEach(resource => {
      const resourcePushed = this.resourcesChecked.find(resource1 => resource.id === resource1.id);
      console.log(resourcePushed);
      if (!resourcePushed && resource.sign) {
        fileName = resource.fileName;
        const message = this.translate.instant('MESSAGE.WARNING-CONFIRM-RUBRIC-POSITION').replace('P_DOCUMENT_NAME', '"' + fileName.bold() + '"');
        Dialog.show(InformType.Warning, this.translate.instant('TITLE.RUBRIC-POSITION-CONFIRM'), message);
        throw new BreakException('Detener el recorrido');
      }
    });
  }

  /**
   * Obtenemos la goelocalización del usuario firmante.
   * @private
   */
  private getCurrentLocation() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.longitude = position.coords.longitude;
        this.latitude = position.coords.latitude;
        this.accuracy = position.coords.accuracy;
        console.log(position.coords);
      }, error => {
        this.longitude = null;
        this.latitude = null;
        this.accuracy = null;
      });
    }
  }

  private saveGeolocation(documents: Document[], personId: number, signatureType: string) {
    // tslint:disable-next-line:prefer-for-of
    for (let index = 0; index < documents.length; index++) {
      const date = new Date(Date.now());
      const documentId = documents[index].id;
      this.geolocation = this.setValueGeolocation(documentId, personId);
      this.geolocation.signatureType = signatureType;
      this.geolocation.longTime = Date.now().toString();
      this.geolocation.timeStamp = date.toString();
      this.geolocation.timeZone = this.getGMT(date);
      this.geolocation.identification = Constant.AUTH_ACCOUNT;
      this.geolocationService.save(this.geolocation).subscribe(resp => {

      }, error => {
        Dialog.show(InformType.Danger, 'Localización', 'No se pudo guardar su ubicación.');
      });
    }
  }

  enableInput(event: any) {
    event.target.removeAttribute('readonly');
  }

  disableInput(event: any) {
    event.target.setAttribute('readonly', 'true');
  }

  private setValueGeolocation(documentId: number, personId: number) {
    this.geolocation = new GeolocationIofesign();
    this.geolocation.latitude = String(this.latitude);
    this.geolocation.longitude = String(this.longitude);
    this.geolocation.accuracy = String(this.accuracy);
    this.geolocation.documentId = documentId;
    this.geolocation.personId = personId;
    this.geolocation.ip = LocalStorage.getIpAddress();
    return this.geolocation;
  }

  private getGMT(date: Date) {
    return date.toTimeString().split(' ')[1];
  }

  get needShowImages(): boolean {
    return !this.hasImagesDocument;
  }


  get typeSignature(): number {
    return this.document._more.typeSignature;
  }

  get isDigitalSignature(): boolean {
    return TypeSignature.DIGITAL === this.document._more.typeSignature;
  }

  get hasConfigRubric(): boolean {
    return this.document._more.hasRubricSettings;
  }

  get hasDragRubric(): boolean {
    return this.document._more.dragRubric;
  }

  get hasIdentityValidation(): boolean {
    return this.document._more.hasIdentityValidation;
  }

  /**
   * Verifica si la empresa a la cual pertenece el usuario tiene activo el uso de monedas(IOFs)
   */
  get hasConfigBalance(): boolean {
    return LocalStorage.hasConfigBalance();
  }

  /**
   * Verifica si los documentos a firmar tiene alguna notificacion.
   */
  get hasNotifyInDocuments(): boolean {
    return this.documents.filter(document => document._more.sent2Visualization === true).length > 0;
  }

  /**
   * Verifica si tiene demos NOTCER
   */
  get hasDemoNotcer(): boolean {
    return LocalStorage.hasDemoNotcer();
  }

  /**
   * Verifica si esta habilitado documentIntegrity para la firma gráfica con integridad del documento.
   */
  get haveDocumentIntegrityToGraficSign() {
    return this.document._more.documentIntegrity;
  }

  get defaultDocumentFrontSrc(): string | ArrayBuffer {
    return this.documentFrontSrc || this.placeHoldItRubric;
  }

  get defaultDocumentRearSrc(): string | ArrayBuffer {
    return this.documentRearSrc || this.placeHoldItRubric;
  }

  get acceptRubricPlacementChecked() {
    const documents: any[] = this.documents.filter(document => document._more.acceptRubricPlacement ? document._more.acceptRubricPlacement : false);
    return documents.length > 0;
  }

  get loadMessageHtml() {
    if (this.acceptRubricPlacementChecked) {
      const message = this.translate.instant('MESSAGE.DRAG-AND-DROP-RUBRIC-TO-DOCUMENTS');
      const note = this.translate.instant('TITLE.ATTENTION');
      return `<strong>¡${note}!</strong><div>${message}</div>`;
    }
  }
}
